import { type PreloadableLazy } from "./lazyWithPreload";

// Small helper to wire prefetching handlers for common routes
export function prefetchOnHover<T extends React.ComponentType<any>>(
  component: PreloadableLazy<T>,
  label?: string
) {
  const key = label ?? (component as any).displayName ?? "component";
  return {
    onMouseEnter: () => {
      try {
        if ((window as any).__ROUTE_PREFETCH_DEBUG) {
          const msg = `[route-prefetch] hover ${key}`;
          (window as any).__ROUTE_PREFETCH_EVENTS = (
            (window as any).__ROUTE_PREFETCH_EVENTS || []
          ).concat(msg);
        }
      } catch {}
      try {
        const w = window as any;
        w.__ROUTE_PREFETCHED = w.__ROUTE_PREFETCHED || new Set<string>();
        if (w.__ROUTE_PREFETCHED.has(key)) return;
        w.__ROUTE_PREFETCHED.add(key);
        component.preload().catch(() => void 0);
      } catch {}
    },
    onFocus: () => {
      try {
        if ((window as any).__ROUTE_PREFETCH_DEBUG) {
          const msg = `[route-prefetch] focus ${key}`;
          (window as any).__ROUTE_PREFETCH_EVENTS = (
            (window as any).__ROUTE_PREFETCH_EVENTS || []
          ).concat(msg);
        }
      } catch {}
      try {
        const w = window as any;
        w.__ROUTE_PREFETCHED = w.__ROUTE_PREFETCHED || new Set<string>();
        if (w.__ROUTE_PREFETCHED.has(key)) return;
        w.__ROUTE_PREFETCHED.add(key);
        component.preload().catch(() => void 0);
      } catch {}
    },
  } as const;
}

export function prefetchOnVisible<T extends React.ComponentType<any>>(
  component: PreloadableLazy<T>,
  label?: string
) {
  let hasPrefetched = false;
  return (el: HTMLElement | null) => {
    if (!el || hasPrefetched) return;
    const io = new IntersectionObserver((entries) => {
      const first = entries[0];
      if (first && first.isIntersecting) {
        hasPrefetched = true;
        try {
          if ((window as any).__ROUTE_PREFETCH_DEBUG) {
            const msg = `[route-prefetch] visible ${
              label ?? (component as any).displayName ?? "component"
            }`;
            (window as any).__ROUTE_PREFETCH_EVENTS = (
              (window as any).__ROUTE_PREFETCH_EVENTS || []
            ).concat(msg);
          }
        } catch {}
        component.preload();
        io.disconnect();
      }
    });
    io.observe(el);
  };
}
